import React, { useEffect, useState } from 'react';
import Link from 'next/link';
import { isEmpty } from 'lodash';
import { Box, Flex, Text, Image, Divider, Button, Spinner } from '@chakra-ui/react';
import { API } from 'config/api';
import PowerBy from './powerby';

const Step4 = ({ nft }) => {
  const [data, setData] = useState({});
  const [nfts, setNfts] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setLoading(true);
    let isSubscribed = true;
    if (!isEmpty(nft)) {
      Promise.all(nft.map((record) => API.get(`/nft/${record.id}`)))
        .then((nfts) => {
          if (isSubscribed) {
            setNfts(nfts.map((i) => i.data.data));
            setData({});
            setLoading(false);
          }
        })
        .catch(() => {
          setLoading(false);
        });
    }
    return () => (isSubscribed = false);
  }, [nft]);

  return (
    <Box w={{ base: '100%', md: '400px' }} m="0 auto" pt="50px" minH="90vh">
      <Flex flexDirection="column" pos="relative" mb="20px" justifyContent="center" alignItems="center">
        <Flex flexDir="column" zIndex={10} justifyContent="center" alignItems="center">
          <Text fontWeight="bold" fontSize="24px" mb="25px">
            Minted Successfully
          </Text>
          {loading ? (
            <Flex p="7px 15px" justifyContent="center" minH="400px" alignItems="center">
              <Spinner thickness="4px" speed="0.65s" emptyColor="gray.200" color="blue.500" size="xl" />
            </Flex>
          ) : (
            !isEmpty(nfts) &&
            nfts.map((nft) => (
              <Box key={nft.id} borderWidth={1} borderRadius={8} bg="#fff" mb="30px">
                <Box pos="relative">
                  <Image
                    objectFit="contain"
                    src={nft?.file?.thumbnail_http_url || '/images/no_image.jpg'}
                    alt=""
                    borderRadius="8px 8px 0 0"
                  />
                </Box>

                <Flex id="card_title" p="15px" flexDirection="column">
                  <Flex mb="5px" alignItems="center">
                    <Text color="#484949" fontSize="14px" fontWeight="500" mr="10px">
                      {nft?.user?.username}
                    </Text>
                    {nft?.user?.is_verified && (
                      <Image bottom="0px" right="2px" w="20px" h="20px" src="/images/icon-verified-icon.svg" alt="" />
                    )}
                  </Flex>
                  <Link href="/">
                    <a>
                      <Text lineHeight={1.2} fontSize="20px" fontWeight="bold">
                        {nft?.name}
                      </Text>
                    </a>
                  </Link>
                </Flex>
              </Box>
            ))
          )}
        </Flex>
      </Flex>
      <Link href="/favorites">
        <a>
          <Button variant="black" w="100%" mt="-10px" mb="15px" size="lg" fontSize="16px">
            View My NFTs
          </Button>
        </a>
      </Link>
      <PowerBy />
    </Box>
  );
};

export default Step4;
